/*
 * Karmagick — movimento.
 * 1. Comparsa allo scorrimento: gli elementi sotto la piega salgono di pochi pixel quando entrano
 *    in vista, a scaletta quando sono in fila (schede prodotto, tessere, colonne).
 * 2. Riposo: le fasce con animazioni senza fine (astrolabio, stelle, nastro) si fermano quando
 *    escono dallo schermo (data-kg-fermo, vedi stile/00-fondamenta.css).
 * È tutto facoltativo: se questo file non parte la pagina resta intera e leggibile, perché lo stato
 * nascosto lo assegna lo script stesso e mai il CSS da solo. Con prefers-reduced-motion non fa nulla.
 * NOTA: da 990 px in su Horizon non fa scorrere la finestra ma .page-wrapper, quindi window.scrollY
 * resta a zero. Qui non serve: IntersectionObserver guarda il viewport comunque. Lo stato della
 * testata si legge in CSS da #header-component[data-sticky-state], e la parallasse dell'apertura
 * è una scroll-timeline CSS (stile/20-home-apertura.css).
 */
const fermo = window.matchMedia('(prefers-reduced-motion: reduce)');

/* Che cosa compare. L'ordine conta poco: ogni elemento viene preso una volta sola. */
const BERSAGLI = [
  '[data-kg-reveal]',
  'main .product-grid__item',
  'main .resource-list__item',
  'main .section-resource-list__content',
  'main .kg-reveal-auto > *',
  'main .kg-tessera',
].join(',');

/* Fasce con animazioni senza fine. */
const FASCE_VIVE = '.kg-hero, .kg-night, .kg-ribbon, .kg-explore__hero';

const visti = new WeakSet();
let osservatore = null;

function libera(el) {
  el.classList.remove('kg-reveal', 'kg-reveal--in');
  el.style.removeProperty('--kg-reveal-delay');
}

function mostra(voci) {
  // Prima si legge tutto, poi si scrive tutto: niente ricalcoli di layout alternati.
  const entrate = voci.filter((voce) => voce.isIntersecting);
  if (!entrate.length) return;

  // Scaletta: posizione fra gli elementi della stessa riga entrati insieme (massimo 5 gradini).
  const righe = new Map();
  for (const voce of entrate) {
    const riga = Math.round(voce.boundingClientRect.top / 8);
    if (!righe.has(riga)) righe.set(riga, []);
    righe.get(riga).push(voce);
  }

  for (const gruppo of righe.values()) {
    gruppo.sort((a, b) => a.boundingClientRect.left - b.boundingClientRect.left);
    gruppo.forEach((voce, indice) => {
      const el = voce.target;
      osservatore.unobserve(el);

      // Chi è già sopra lo schermo (salto a un'àncora, ritorno con «indietro») non si anima.
      if (voce.boundingClientRect.bottom < 0) {
        libera(el);
        return;
      }

      el.style.setProperty('--kg-reveal-delay', `${Math.min(indice, 5) * 70}ms`);
      el.classList.add('kg-reveal--in');

      // A comparsa finita si toglie tutto: nessuna regola nostra resta sull'elemento.
      // 'transitionend' risale anche dai figli (l'hover di una scheda): si ascolta solo il proprio.
      const finito = (evento) => {
        if (evento && (evento.target !== el || evento.propertyName !== 'opacity')) return;
        el.removeEventListener('transitionend', finito);
        el.removeEventListener('transitioncancel', finito);
        clearTimeout(scadenza);
        libera(el);
      };
      // Rete di sicurezza: se la transizione non finisce mai (scheda nascosta, nodo spostato).
      const scadenza = setTimeout(finito, 2200);
      el.addEventListener('transitionend', finito);
      el.addEventListener('transitioncancel', finito);
    });
  }
}

function prepara(radice = document) {
  if (fermo.matches || !('IntersectionObserver' in window)) return;
  if (!osservatore) {
    // Margine alto enorme: chi salta la soglia (un salto in fondo pagina) risulta comunque
    // «entrato» e viene liberato, invece di restare invisibile sopra lo schermo.
    osservatore = new IntersectionObserver(mostra, { rootMargin: '100000px 0px -8% 0px', threshold: 0.08 });
  }

  const altezza = window.innerHeight;
  const daNascondere = [];
  for (const el of radice.querySelectorAll(BERSAGLI)) {
    if (visti.has(el)) continue;
    visti.add(el);
    // Quello che è già in vista al caricamento non si tocca: niente lampi, niente LCP rimandato.
    if (el.getBoundingClientRect().top < altezza) continue;
    daNascondere.push(el);
  }
  for (const el of daNascondere) {
    // Un bersaglio dentro un altro bersaglio comparirebbe due volte.
    if (el.parentElement?.closest('.kg-reveal')) continue;
    el.classList.add('kg-reveal');
    osservatore.observe(el);
  }
}

function riposo() {
  if (!('IntersectionObserver' in window)) return;
  const fasce = document.querySelectorAll(FASCE_VIVE);
  if (!fasce.length) return;
  const guardia = new IntersectionObserver(
    (voci) => {
      for (const voce of voci) voce.target.toggleAttribute('data-kg-fermo', !voce.isIntersecting);
    },
    { rootMargin: '10% 0px' }
  );
  for (const fascia of fasce) guardia.observe(fascia);
}

function avvia() {
  prepara();
  riposo();

  // Horizon aggiunge schede con lo scorrimento infinito e riscrive la griglia quando si filtra:
  // i nodi nuovi arrivano senza classi, quindi visibili. Qui si dà la comparsa solo a quelli
  // che nascono sotto la piega.
  const principale = document.querySelector('main');
  if (principale && 'MutationObserver' in window) {
    let inAttesa = 0;
    new MutationObserver((mutazioni) => {
      if (!mutazioni.some((m) => m.addedNodes.length)) return;
      clearTimeout(inAttesa);
      inAttesa = setTimeout(() => prepara(principale), 60);
    }).observe(principale, { childList: true, subtree: true });
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia, { once: true });
else avvia();

/*
 * 3. «Il tuo paese» nella tabella delle soglie di spedizione: la riga del paese di chi legge
 *    si accende da sola. Shopify.country è il paese del mercato attivo (ISO a due lettere).
 *    La riga si riconosce dalla SOGLIA scritta nella prima cella, non dal nome del paese: la
 *    pagina è tradotta in diciannove lingue e «Czechia» si scrive in diciannove modi, 29 no.
 *    Le soglie ripetono snippets/kg-carrello-soglia.liquid (fonte: gli sconti di spedizione su
 *    Shopify, riassunti in Memory/STATE.json): se cambiano lì, vanno aggiornate anche qui.
 */
const SOGLIE = {
  SK: 19,
  AT: 29, CZ: 29, HR: 29, HU: 29,
  DE: 39, PL: 39, SI: 39,
  BE: 49, BG: 49, DK: 49, LT: 49, LU: 49, NL: 49,
  IT: 59,
  EE: 59, FR: 59, LV: 59, PT: 59, RO: 59,
  ES: 69, IE: 69,
  FI: 79, SE: 79,
  GR: 99,
};

function tuoPaese() {
  const soglia = SOGLIE[window.Shopify?.country];
  if (!soglia) return;
  for (const riga of document.querySelectorAll('main .rte table tbody tr')) {
    const sogliePaese = window.Shopify?.country === 'IT' ? ['59', '69'] : [String(soglia)];
    riga.classList.toggle('kg-tuo-paese', sogliePaese.includes(riga.cells[0]?.textContent.replace(/\D/g, '')));
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tuoPaese, { once: true });
else tuoPaese();
// snippets/kg-lingua.liquid corregge il paese dopo il caricamento, alla prima visita.
document.addEventListener('kg:paese', tuoPaese);
